import Component from "@glimmer/component"
import styles from "./school-search-after.module.css"

export default class UserOnboardingSchoolSearchAfterComponent extends Component {
  readonly styles = styles
}
